import React, { useState, Fragment, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
} from "reactstrap"
import { Link } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import moment from "moment"

import {
  getBusinesses,
  editBusinessClean,
  addBusinessClean,
} from "../../store/actions"
import "../../assets/scss/datatables.scss"
import { useDispatch, useSelector } from "react-redux"
import BusinessForm from "./BusinessForm"

const BusinessesListTable = props => {
  const dispatch = useDispatch()
  const { SearchBar } = Search

  const [insertModal, setInsertModal] = useState(false)
  const [updateModal, setUpdateModal] = useState(false)
  const [business, setBusiness] = useState({
    idNegocio: 0,
  })

  const { error, loading, done, businesses } = useSelector(state => ({
    error: state.BusinessesList.error,
    loading: state.BusinessesList.loading,
    businesses: state.BusinessesList.businesses,
    done: state.BusinessesList.done,
  }))

  useEffect(() => {
    dispatch(getBusinesses())
  }, [])

  const handleEdit = business => {
    setBusiness(business)
    setUpdateModal(true)
  }

  const buttonActions = (cell, row, rowIndex, extraData) => {
    return (
      <button
        className="btn btn-primary"
        key={`button-${row.idNegocio}`}
        onClick={() => handleEdit(row)}
      >
        Editar
      </button>
    )
  }

  const columns = [
    {
      dataField: "idNegocio",
      text: "Id",
      sort: false,
      hidden: true,
    },
    {
      dataField: "nombreNegocio",
      text: "Nombre del negocio",
      sort: true,
    },
    {
      dataField: "estatus",
      text: "Estatus",
      sort: true,
      align: "center",
      headerAlign: "center",
      // eslint-disable-next-line react/display-name
      formatter: (cell, row, rowIndex, extraData) => {
        return (
          <h4 style={{ marginBottom: 0 }} key={`status-${row.idNegocio}`}>
            <span
              className={`pt-2 badge bg-${row.estatus ? "success" : "warning"}`}
            >
              {row.estatus ? "Activo" : "Inactivo"}
            </span>
          </h4>
        )
      },
    },
    {
      dataField: "actions",
      text: "Acciones",
      sort: false,
      align: "center",
      headerAlign: "center",
      headerStyle: {
        width: "150px",
      },
      formatter: buttonActions,
    },
  ]

  const pageOptions = {
    sizePerPage: 10,
    totalSize: businesses?.length,
    custom: true,
    showTotal: true,
  }

  const defaultSorted = [{ dataField: "nombreNegocio", order: "asc" }]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
  }

  return loading || businesses === undefined ? (
    <div className="mt-3 mb-3">
      <div className="spinner-chase">
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
      </div>
    </div>
  ) : (
    <Fragment>
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="idNegocio"
        columns={columns}
        data={businesses}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="idNegocio"
            columns={columns}
            data={businesses}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <Row className="mb-2 pt-3">
                  <Col lg={2} md={3} sm={4} xs={6}>
                    <div className="d-grid">
                      <button
                        className="btn btn-primary btn-rounded"
                        onClick={() => setInsertModal(true)}
                      >
                        <i className="fa fa-plus"></i> Agregar negocio
                      </button>
                    </div>
                  </Col>
                  <Col
                    lg={{ size: 2, offset: 8 }}
                    md={{ size: 3, offset: 6 }}
                    sm={{ size: 4, offset: 4 }}
                    xs={6}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <SearchBar
                          {...toolkitProps.searchProps}
                          placeholder="Buscar"
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <Fragment>
                      <BootstrapTable
                        keyField={"idNegocio"}
                        bordered={false}
                        striped={true}
                        defaultSorted={defaultSorted}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"thead-light"}
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                      />
                      {businesses?.length <= 0 && (
                        <Row>
                          <Col md={12} className="text-center">
                            -- No hay registros --
                          </Col>
                        </Row>
                      )}
                    </Fragment>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
      <Modal
        isOpen={insertModal}
        backdrop={"static"}
        size="lg"
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title">Registrar negocio</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setInsertModal(false)
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <BusinessForm
            onDone={() => {
              dispatch(addBusinessClean())
              dispatch(getBusinesses())
              setInsertModal(false)
            }}
            onCancel={() => {
              dispatch(addBusinessClean())
              setInsertModal(false)
            }}
            insert={true}
            business={{
              idNegocio: 0,
              nombreNegocio: "",
              estatus: true,
            }}
          />
        </div>
      </Modal>
      <Modal
        isOpen={updateModal}
        backdrop={"static"}
        size="lg"
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title">Editar negocio</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setUpdateModal(false)
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <BusinessForm
            onDone={() => {
              dispatch(editBusinessClean())
              dispatch(getBusinesses())
              setUpdateModal(false)
            }}
            onCancel={() => {
              dispatch(editBusinessClean())
              setUpdateModal(false)
            }}
            insert={false}
            business={business}
          />
        </div>
      </Modal>
    </Fragment>
  )
}

BusinessesListTable.propTypes = {
  groups: PropTypes.array,
}

export default BusinessesListTable
